import React from 'react';
class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
        };
    }
    componentDidMount() {
        this.renderPage();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (nextProps.actualZoom !== this.props.actualZoom ||
            nextProps.onSizeReady !== this.props.onSizeReady ||
            nextProps.page !== this.props.page ||
            nextProps.image !== this.props.image ||
            nextState.image !== this.state.image);
    }
    renderPage() {
        const { page, onSizeReady, image } = this.props;
        page.file
            .getPage(page.key)
            .then((respPage) => {
            const scale = 1;
            const viewport = respPage.getViewport(scale * 2);
            if (image)
                this.canvas = document.createElement('canvas');
            const canvas = this.canvas;
            if (!canvas)
                return;
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: context,
                viewport,
            };
            respPage.render(renderContext).promise.then(() => {
                const { order, page, image, onPageComplete, onSizeReady } = this.props;
                if (typeof onSizeReady === 'function') {
                    const rect = canvas.getBoundingClientRect();
                    const height = rect.bottom - rect.top;
                    const width = rect.right - rect.left;
                    onSizeReady(width, height);
                }
                if (image)
                    this.convertCanvasToImage(canvas);
                else
                    onPageComplete(order, page.key, false);
            });
        })
            .catch((error) => console.error(error));
    }
    convertCanvasToImage(canvas) {
        const imageData = canvas.toDataURL('image/png');
        const { order, page, image, onPageComplete } = this.props;
        this.setState({ image: imageData }, onPageComplete(order, page.key, image));
    }
    renderObject() {
        if (!this.props.image) {
            return (React.createElement("canvas", { style: { width: `${this.props.actualZoom}%`, height: 'auto' }, ref: (node) => (this.canvas = node) }));
        }
        return React.createElement("img", { src: this.state.image, alt: "", style: { height: '1500px' } });
    }
    render() {
        return this.renderObject();
    }
}
export default Page;
